<template>
  <div class="c-entrepreneur-parallax" :class="rootClass">
    <div class="c-entrepreneur-parallax__inner">
      <!-- small img -->
      <entrepreneur-parallax-small :data="data.primary" :hide-background="hideSmallBackground" />
      <!-- large img -->
      <entrepreneur-parallax-large :data="data.primary" :natural="naturalLarge" />
    </div>
  </div>
</template>

<script>
import EntrepreneurParallaxLarge from "components/EntrepreneurParallax/EntrepreneurParallaxLarge";
import EntrepreneurParallaxSmall from "components/EntrepreneurParallax/EntrepreneurParallaxSmall";
export default {
  components: {
    EntrepreneurParallaxSmall,
    EntrepreneurParallaxLarge
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hideSmallBackground() {
      return this.data.primary.hide_small_background === true;
    },
    naturalLarge() {
      return this.data.primary.large_image_natural === true;
    },
    rootClass() {
      return {
        "c-entrepreneur-parallax--no-small-bg": this.hideSmallBackground,
        "c-entrepreneur-parallax--natural": this.naturalLarge
      };
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-parallax--no-small-bg {
  @media #{$breakpoint-vertical} {
    .c-entrepreneur-parallax-large:not(.-natural) {
      margin-top: #{$card-max-width * -0.5};
    }
  }
}
</style>

<style lang="scss" scoped>
.c-entrepreneur-parallax {
  @include sharedParentBody;
  padding-top: var(--grid-gutter-double); // add a bit of padding to compensate the paralax effect
  @media #{$breakpoint-horizontal} {
    padding-top: 0px;
  }

  &__inner {
    display: flex;
    flex-direction: column;

    @media #{$breakpoint-horizontal} {
      flex-direction: row;
      height: 100%;
    }
  }
}
</style>
